import { useCountUsersQuery } from 'api/UsersEndPoints';
import Loader from 'shared/component/Loader';
import Metric from 'shared/routes/components/Metric/Metric';

const UserCountMetric = () => {
  const { data, isLoading } = useCountUsersQuery();

  return <Metric label="Number of Users">{isLoading ? <Loader /> : data?.count}</Metric>;
};

export default UserCountMetric;
